import { createContext, useContext } from "react";

export type SourceRating = "positive" | "negative";

export interface SourceFeedbackContextValue {
  /** Submit feedback for a specific source chunk. Errors are swallowed. */
  submitFeedback: (
    chunkId: string,
    rating: SourceRating,
    messageId: string,
  ) => void;
  /** Get the current rating for a chunk (undefined = not yet rated) */
  getRating: (chunkId: string) => SourceRating | undefined;
  /** Subscribe to rating changes (for useSyncExternalStore) */
  subscribe: (listener: () => void) => () => void;
  /** Snapshot getter for useSyncExternalStore */
  getSnapshot: () => ReadonlyMap<string, SourceRating>;
}

export const SourceFeedbackContext =
  createContext<SourceFeedbackContextValue | null>(null);

export function useSourceFeedback(): SourceFeedbackContextValue | null {
  return useContext(SourceFeedbackContext);
}
